// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","bold":"G7a78b8 Gd6846a","header":"Gd65f9d","subHeader":"G0e9fee","dateTime":"G52b22d","button":"Gc1c175"};